// extracted by mini-css-extract-plugin
module.exports = {"backgroundPicture":"background_backgroundPicture__1p5ck","background":"background_background__15qQM","homepage":"background_homepage__28rXd"};